<template>
	<div>
		<auth-container v-if="$route.name === 'SrWorkOrderList'" :page="page">
			<h2 class="mb-4">Work Orders</h2>

			<div class="mx-auto">
				<b-row class="mb-3" align-v="end">
					<b-col lg="6">
						<b-form inline>
							<b-input-group>
								<b-form-input v-model="table.filter" placeholder="Search..." @input="filterChg"></b-form-input>

								<b-input-group-append class="pointer mr-2">
									<b-input-group-text @click="clearFilter">
										<font-awesome-icon :icon="['fas', 'times']" />
									</b-input-group-text>
								</b-input-group-append>
							</b-input-group>
							<b-button variant="primary" type="button" @click="table.showAdvancedFilter = !table.showAdvancedFilter">Advanced Filter</b-button>
						</b-form>
					</b-col>
					<b-col lg="6" class="text-right">
						<div class="ml-auto">
							Showing {{showingFirst}} - {{showingLast}}
							of {{table.total}}
						</div>
					</b-col>
				</b-row>

				<b-collapse v-model="table.showAdvancedFilter" class="my-3">
					<b-card bg-variant="light">
						<b-row>
							<b-col lg="4">
								<div class="form-group row">
									<label for="advancedFilter.workOrderNumber" class="col-lg-5 col-form-label">Work Order #</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.workOrderNumber"
													 v-model="advancedFilter.workOrderNumber"
													 :data="advancedFilter.options.workOrderNumber"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.name" class="col-lg-5 col-form-label">Name</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.projectName"
													 v-model="advancedFilter.name"
													 :data="advancedFilter.options.name"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.contractor" class="col-lg-5 col-form-label">Contractor</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.contractor"
													 v-model="advancedFilter.contractor"
													 :data="advancedFilter.options.contractor"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.pocPrimary" class="col-lg-5 col-form-label">Point of Contact</label>
									<div class="col-lg-7">
										<b-typeahead id="advancedFilter.pocPrimary"
													 v-model="advancedFilter.pocPrimary"
													 :data="advancedFilter.options.pocPrimary"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>
							</b-col>
							<b-col lg>
								<div class="form-group row">
									<label for="advancedFilter.fundingType" class="col-lg-3 col-form-label">Funding Type</label>
									<div class="col-lg-9">
										<b-typeahead id="advancedFilter.fundingType" style="max-width:260px"
													 v-model="advancedFilter.fundingType"
													 :data="setOptions.fundingTypes"
													 :minMatchingChars="1" showAllResults showOnFocus>
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.fundingSource" class="col-lg-3 col-form-label">Funding Source ID</label>
									<div class="col-lg-9">
										<b-typeahead id="advancedFilter.fundingSource" style="max-width:260px"
													 v-model="advancedFilter.fundingSource"
													 :data="advancedFilter.options.fundingSource"
													 :max-matches="100" :minMatchingChars="1">
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.projectType" class="col-lg-3 col-form-label">Project Type</label>
									<div class="col-lg-9">
										<b-typeahead id="advancedFilter.projectType" style="max-width:260px"
													 v-model="advancedFilter.projectType"
													 :data="setOptions.projectTypes"
													 :minMatchingChars="1" showAllResults showOnFocus>
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.fundingType" class="col-lg-3 col-form-label">Project Subtype</label>
									<div class="col-lg-9">
										<b-typeahead id="advancedFilter.projectSubtype" style="max-width:260px"
													 v-model="advancedFilter.projectSubtype"
													 :data="setOptions.projectSubtypes"
													 :minMatchingChars="1" showAllResults showOnFocus>
										</b-typeahead>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.executionDate.start" class="col-lg-3 col-form-label">Execution Date</label>
									<div class="col-lg-9">
										<div class="d-flex align-items-center justify-content-start">
											<div class="mr-2">
												<b-input-group>
													<b-form-datepicker id="advancedFilter.executionDate.start" v-model="advancedFilter.executionDate.start"
																	   label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.executionDate.start = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
											<div>
												<b-input-group>
													<b-form-datepicker id="advancedFilter.executionDate.end" v-model="advancedFilter.executionDate.end"
																	   label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.executionDate.end = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
										</div>
									</div>
								</div>

								<div class="form-group row">
									<label for="advancedFilter.completionDate.start" class="col-lg-3 col-form-label">Completion Letter Date</label>
									<div class="col-lg-9">
										<div class="d-flex align-items-center justify-content-start">
											<div class="mr-2">
												<b-input-group>
													<b-form-datepicker id="advancedFilter.completionDate.start" v-model="advancedFilter.completionDate.start"
																	   label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.completionDate.start = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
											<div>
												<b-input-group>
													<b-form-datepicker id="advancedFilter.completionDate.end" v-model="advancedFilter.completionDate.end"
																	   label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

													<b-input-group-append class="pointer">
														<b-input-group-text @click="advancedFilter.completionDate.end = null">
															<font-awesome-icon :icon="['fas', 'times']" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</div>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>
						<hr class="my-3" />
						<div>
							<b-button variant="primary" type="button" @click="get" class="mr-2">Apply</b-button>
							<b-button variant="secondary" type="button" @click="clearAdvancedFilter" class="mr-2">Clear</b-button>
							<b-button variant="secondary" type="button" @click="table.showAdvancedFilter = false">Close</b-button>
						</div>
					</b-card>
				</b-collapse>

				<b-table striped responsive table-class="table-fixed-height border-bottom table-grid" sticky-header="60vh"
						 small show-empty
						 :items="items" :busy="table.loading"
						 :fields="table.fields"
						 :no-local-sorting="true"
						 :sort-by.sync="table.sort"
						 :sort-desc.sync="table.reverse"
						 @sort-changed="sortChg">
					<template #table-busy>
						<div class="text-center my-4">
							<font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
						</div>
					</template>
					<template #cell(edit)="data">
						<router-link :to="`${data.item.id}`" append>
							<font-awesome-icon :icon="['fas', 'edit']" />
						</router-link>
					</template>
					<template #cell(fundingSourceId)="data">
						<router-link :to="`/sr/fundingsources/${data.value}`">{{data.item.fundingSource}}</router-link>
					</template>
					<template #empty>
						<h4>No records found.</h4>
					</template>
					<template #emptyfiltered>
						<h4>No records found matching "{{table.filter}}".</h4>
					</template>
				</b-table>
			</div>

			<fixed-action-bar>
				<router-link v-if="!isReadOnly" to="create" append class="btn btn-success mr-2">
					Create
				</router-link>
				<b-dropdown variant="primary" text="Download CSVs" dropup class="mr-2">
					<b-dropdown-text><json-to-csv :api-url="`${apiUrl}/export/${$route.params.atype}`" :filename="apiUrl" variant="link" text="Download Work Orders" /></b-dropdown-text>
					<b-dropdown-text><json-to-csv :api-url="`srworkorderrevisions/export`" filename="srworkorderrevisions" variant="link" text="Download Work Order Revisions" /></b-dropdown-text>
					<b-dropdown-text><json-to-csv :api-url="`srworkorderdams/export`" filename="srworkorderdams" variant="link" text="Download Work Order TPNs/Dams" /></b-dropdown-text>
				</b-dropdown>
				<b-dropdown v-if="isAuthorized(roleNames.superAdmin)" variant="primary" text="Import" dropup class="mr-2">
					<b-dropdown-text><b-button variant="link" @click="page.showModal = true" class="mr-2" style="white-space: nowrap;">Import Work Orders</b-button></b-dropdown-text>
					<b-dropdown-text><b-button variant="link" @click="page.showModal1 = true" class="mr-2" style="white-space: nowrap;">Import Work Order Revisions</b-button></b-dropdown-text>
					<b-dropdown-text><b-button variant="link" @click="page.showModal2 = true" class="mr-2" style="white-space: nowrap;">Import Work Order TPNs/Dams</b-button></b-dropdown-text>
				</b-dropdown>
				<b-pagination class="ml-auto mb-0" v-if="table.total > table.itemsPerPage" size="md" :total-rows="table.total" v-model="table.currentPage" :per-page="table.itemsPerPage" @change="pageChg" />
			</fixed-action-bar>

			<b-modal v-model="page.showModal" title="Upload" scrollable size="lg">
				<error-list :errors="page.saveErrors"></error-list>
				<success-alert ref="savedAlert" text="Changes saved." />

				<vue-dropzone ref="addFile" id="addFile" :options="dropzoneOptions" @vdropzone-success="fileUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<div class="mt-3">
					<strong>IMPORTANT:</strong>
				</div>
				<ul>
					<li>Use the Download Template button to get the required columns.</li>
					<li>Column headers **must match** the template.</li>
					<li>Existing work order numbers already in the database will be updated.</li>
					<li>Include the data for a single revision. You can upload other revisions after the entry is created.</li>
				</ul>

				<div slot="modal-footer">
					<json-to-csv :json-data="template" :filename="`${apiUrl}-template`" text="Download Template" class="mr-2" />
					<b-button type="button" variant="primary" @click="page.showModal = false" class="ml-1">Close</b-button>
				</div>
			</b-modal>

			<b-modal v-model="page.showModal1" title="Upload Work Order Revisions" scrollable size="lg">
				<error-list :errors="page.saveErrors"></error-list>
				<success-alert ref="savedAlert" text="Changes saved." />

				<vue-dropzone ref="addFile1" id="addFile1" :options="dropzoneOptions1" @vdropzone-success="fileUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<div class="mt-3">
					<strong>IMPORTANT:</strong>
				</div>
				<ul>
					<li>Use the Download Template button to get the required columns.</li>
					<li>Column headers **must match** the template.</li>
					<li>Work order numbers must already exist in the database.</li>
				</ul>

				<div slot="modal-footer">
					<json-to-csv :json-data="revisionTemplate" :filename="`srworkorderrevisions-template`" text="Download Template" class="mr-2" />
					<b-button type="button" variant="primary" @click="page.showModal1 = false" class="ml-1">Close</b-button>
				</div>
			</b-modal>

			<b-modal v-model="page.showModal2" title="Upload Work Order TPNs/Dams" scrollable size="lg">
				<error-list :errors="page.saveErrors"></error-list>
				<success-alert ref="savedAlert" text="Changes saved." />

				<vue-dropzone ref="addFile2" id="addFile2" :options="dropzoneOptions2" @vdropzone-success="fileUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<div class="mt-3">
					<strong>IMPORTANT:</strong>
				</div>
				<ul>
					<li>Use the Download Template button to get the required columns.</li>
					<li>Column headers **must match** the template.</li>
					<li>Work order numbers and TPNs must already exist in the database.</li>
					<li>Multiple revisions for the work order TPNs may be added in separate rows; just use a different revision number.</li>
				</ul>

				<div slot="modal-footer">
					<json-to-csv :json-data="damTemplate" :filename="`srworkorderdams-template`" text="Download Template" class="mr-2" />
					<b-button type="button" variant="primary" @click="page.showModal2 = false" class="ml-1">Close</b-button>
				</div>
			</b-modal>
		</auth-container>
		<router-view></router-view>
	</div>
</template>

<script>
	import vue2Dropzone from 'vue2-dropzone';
	import 'vue2-dropzone/dist/vue2Dropzone.min.css';
	import _ from 'underscore';

	export default {
		name: 'SrWorkOrderList',
		components: {
			vueDropzone: vue2Dropzone
		},
		data() {
			return {
				apiUrl: 'srworkorders',
				page: {
					errors: [],
					loading: true,
					showLogin: false,
					saveErrors: [],
					showModal: false,
					showModal1: false,
					showModal2: false
				},
				dropzoneOptions: {
					url: '/api/srworkorders/upload/',
					headers: this.getTokenHeader().headers,
					acceptedFiles: '.csv'
				},
				dropzoneOptions1: {
					url: `/api/srworkorderrevisions/upload`,
					headers: this.getTokenHeader().headers,
					acceptedFiles: '.csv'
				},
				dropzoneOptions2: {
					url: `/api/srworkorderdams/upload`,
					headers: this.getTokenHeader().headers,
					acceptedFiles: '.csv'
				},
				table: {
					fields: [
						{ key: 'edit', label: '', stickyColumn: true },
						{ key: 'workOrderNumber', label: 'Work Order #', sortable: true },
						{ key: 'name', sortable: true },
						{ key: 'executionDate', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
						{ key: 'contractor', sortable: true },
						{ key: 'pocPrimary', label: 'POC#1', sortable: true },
						{ key: 'pocSecondary', label: 'POC#2', sortable: true },
						{ key: 'fundingType', sortable: true },
						{ key: 'fundingSourceId', label: 'Funding Source', sortable: true },
						{ key: 'projectType', sortable: true },
						{ key: 'projectSubtype', sortable: true },
						{ key: 'completionDate', label: 'Completion Letter Date', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } }
					],
					sort: 'workOrderNumber',
					reverse: false,
					itemsPerPage: 100,
					filter: null,
					currentPage: 1,
					total: 0,
					loading: false,
					showAdvancedFilter: false
				},
				items: [],
				advancedFilter: {
					workOrderNumber: null,
					name: null,
					contractor: null,
					pocPrimary: null,
					pocSecondary: null,
					fundingType: null,
					fundingSource: null,
					projectType: null,
					projectSubtype: null,
					executionDate: {
						start: null,
						end: null
					},
					completionDate: {
						start: null,
						end: null
					},
					options: {
						workOrderNumber: [],
						name: [],
						contractor: [],
						pocPrimary: [],
						fundingSource: []
					}
				},
				setOptions: {
					fundingTypes: [],
					projectTypes: [],
					projectSubtypes: []
				},
				template: [{
					workOrderNumber: null,
					name: null,
					executionDate: null,
					contractor: null,
					pocPrimary: null,
					pocSecondary: null,
					fundingType: null,
					projectType: null,
					projectSubtype: null,
					completionLetterDate: null,
					fundingSource: null,
					revisionNumber: null,
					revisionDate: null,
					expirationDate: null,
					notes: null
				}],
				revisionTemplate: [{
					workOrderNumber: null,
					revisionNumber: null,
					revisionDate: null,
					expirationDate: null,
					notes: null
				}],
				damTemplate: [{
					workOrderNumber: null,
					tpn: null,
					revisionNumber: null,
					fundingAmount: null,
					revisionDate: null,
					notes: null
				}]
			}
		},
		computed: {
			showingFirst() {
				return this.table.total === 0 ? 0 : (this.table.currentPage - 1) * this.table.itemsPerPage + 1
			},
			showingLast() {
				var max = (this.table.currentPage - 1) * this.table.itemsPerPage + this.table.itemsPerPage
				return max > this.table.total ? this.table.total : max;
			},
			advancedFilterWorkOrderNumber() {
				return this.advancedFilter.workOrderNumber;
			},
			advancedFilterName() {
				return this.advancedFilter.name;
			},
			advancedFilterContractor() {
				return this.advancedFilter.contractor;
			},
			advancedFilterPocPrimary() {
				return this.advancedFilter.pocPrimary;
			},
			advancedFilterFundingSource() {
				return this.advancedFilter.fundingSource;
			},
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get',
			advancedFilterWorkOrderNumber: _.debounce(function (query) { this.find('workOrderNumber', query) }, 500),
			advancedFilterName: _.debounce(function (query) { this.find('name', query) }, 500),
			advancedFilterContractor: _.debounce(function (query) { this.find('contractor', query) }, 500),
			advancedFilterPocPrimary: _.debounce(function (query) { this.find('pocPrimary', query) }, 500),
			advancedFilterFundingSource: _.debounce(function (query) { this.find('fundingSource', query) }, 500),
		},
		methods: {
			getDb() {
				let sort = this.table.reverse ? this.table.sort + '_desc' : this.table.sort;
				let filter = this.table.filter !== null ? `&filter=${encodeURIComponent(this.table.filter)}` : '';

				let filterComplex = '';
				let filterValues = [];
				let stringFields = ['workOrderNumber', 'name', 'contractor', 'pocPrimary', 'fundingSource', 'fundingType', 'projectType', 'projectSubtype'];
				let twoPartFields = ['executionDate', 'completionDate'];

				for (let f of stringFields) {
					if (!this.isNullOrEmpty(this.advancedFilter[f])) {
						filterValues.push(`${f}:${this.advancedFilter[f]}`);
					}
				}

				for (let f of twoPartFields) {
					if (!this.isNullOrEmpty(this.advancedFilter[f].start) || !this.isNullOrEmpty(this.advancedFilter[f].end)) {
						let s = this.advancedFilter[f].start;
						let e = this.advancedFilter[f].end;
						s = s === null ? 'any' : s;
						e = e === null ? 'any' : e;
						filterValues.push(`${f}:${s},${e}`);
					}
				}

				if (filterValues.length > 0) filterComplex = '&filterComplex=' + filterValues.join('|');

				return this.$http.get(`${this.apiUrl}?sort=${sort}&page=${this.table.currentPage}&perPage=${this.table.itemsPerPage}${filter}${filterComplex}`, this.getTokenHeader());
			},
			async filterChg() {
				this.table.currentPage = 1;
				_.debounce(await this.get(), 500);
			},
			async pageChg(page) {
				this.table.currentPage = page;
				await this.get();
			},
			async sortChg(ctx) {
				this.table.sort = ctx.sortBy;
				this.table.reverse = ctx.sortDesc;
				this.table.specialSort = undefined;

				await this.get();
			},
			async get() {
				this.page.errors = [];
				this.table.loading = true;

				try {
					const response1 = await this.$http.get(`${this.apiUrl}/options`, this.getTokenHeader());
					this.setOptions = response1.data;

					const response = await this.getDb();
					this.log(response.data);

					if (response.data.items.length == 0 && this.table.currentPage > 1) {
						this.table.currentPage--;
						await this.get();
					}

					this.items = response.data.items;
					this.table.total = response.data.total;
				} catch (error) {
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.errors = this.logError(error);
				}

				this.table.loading = false;
				this.page.loading = false;
			},
			async fileUploaded(file, response) {
				this.log(file);
				this.log(response);
				this.page.saveErrors = [];
				await this.get();
			},
			uploadError(file, message, xhr) {
				this.log(file);
				this.log(xhr);
				this.page.saveErrors.push(message);
			},
			async find(field, query) {
				try {
					const response = await this.$http.get(`/${this.apiUrl}/find/${field}/${query}`, this.getTokenHeader());
					this.advancedFilter.options[field] = response.data != '' ? response.data : [];
				} catch (error) {
					this.page.errors = this.logError(error);
				}
			},
			async clearFilter() {
				this.table.filter = null;
				await this.get();
			},
			async clearAdvancedFilter() {
				this.advancedFilter = {
					workOrderNumber: null,
					name: null,
					contractor: null,
					pocPrimary: null,
					pocSecondary: null,
					fundingType: null,
					fundingSource: null,
					projectType: null,
					projectSubtype: null,
					executionDate: {
						start: null,
						end: null
					},
					completionDate: {
						start: null,
						end: null
					},
					options: {
						workOrderNumber: [],
						name: [],
						contractor: [],
						pocPrimary: [],
						fundingSource: []
					}
				};

				await this.get();
			}
		}
	}
</script>